var map = {
	"./poly-1.png": "cf45",
	"./poly-2.png": "fe03",
	"./poly-3.png": "0520",
	"./poly-4.png": "5301",
	"./poly-5.png": "a614",
	"./poly-6.png": "560f",
	"./poly-7.png": "c35a",
	"./poly-8.png": "eb89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd7d";